import {InitPage} from "../index";

declare var newStandardPath
declare var nonStandardItemPath: string;

declare global {
    interface JQuery {
        update(event: any, ui: any);
        sortable(update);
    }
}

class ElcStandard {
    constructor() {
        const standardPositionOrderSave = $("#standardPositionLine").data("save-path");

        const _this = this;

        InitPage("standards new step_2", () => {
            let pagePath = window.location.href;
            if(pagePath.indexOf("new") > -1 && pagePath.indexOf("item_number=") > -1)
            {
                var result = $('#elc_standard_area_id option:contains("Assembly")').filter(function() {
                    return $(this).text() === 'Assembly';
                });
                result.prop('selected', true);
            }
            _this.setAreaRate();
            _this.calculateStandardDlUnitCost();

        });

        $('.editBtn').on('click',function(e){
            e.preventDefault();
            const _anchor = this;
            let editPath = $(_anchor).data("edit-path");
            $.ajax({
                url: editPath,
                method: "get",
            }).then(response => {
                $("#elc_standard_position_position_id").val(response.id);
                $('#elc_standard_position_position_id option[value=' + response.id + ']').prop('selected', true);
                $("#elc_standard_position_people_count").val(response.people_count);
                $("#elc_standard_position_making_unit_time").val(response.making_unit_time);
                $("#production-position-form").attr("action",editPath.replace(/edit/g,""));
                $("#production-position-form").attr("method",'patch');                
            });
        });


        $("#elc_standard_area_id").on("change",function(){
            _this.setAreaRate();
            _this.calculateStandardDlUnitCost();
        });

        $("#elc_standard_fatigue").on("input",function(){
            _this.calculatePPM();
            _this.calculateStandardDlUnitCost();
        });

        $("#elc_standard_attachment_file").on("change",function(){
            var filename = $("#elc_standard_attachment_file").val();
            $("#uplaoded-file").val(filename);
        });

        $("#standardPositionLine").sortable({
            update: function( event, ui ) {
            var data = $(this).sortable("toArray");
              $.ajax({
                type: "POST",
                data: { ids: data },
                url: standardPositionOrderSave,
                success: function (data) {
                    $.each(data["saved_changes"], function(index, value) {
                        $("#orderPositionFor"+value[0]).text(value[1])
                    });
                }
              });
             }
          });

          $('.item_number').on('change', function(e) {
            var itemAlu = $('.item_number option:selected').val();
            if(itemAlu != "")
                window.location.href = newStandardPath + '?item_number=' + encodeURIComponent(String(itemAlu));
          })
    }


    initializeHTML() {
        const _this = this;
        $('.item_number').select2({
            placeholder: 'Search and Select Item',
            allowClear: true,
            ajax: {
                url: nonStandardItemPath
                },
            dropdownParent: $("#item-list"),
            templateSelection: _this.updateItemMetadata
          });

    }

    updateItemMetadata(e: any) {
        return e.text;
    }

    setAreaRate() {
        const standardHourlyRate = $("#elc_standard_area_id").find(":selected").attr("data-rate");
        if (standardHourlyRate) {
            $("#area_rate").val(standardHourlyRate);
            $("#minute_rate").val((parseFloat(standardHourlyRate) / 60.0).toFixed(2));
        }
        else {
            $("#area_rate").val("0.0");
            $("#minute_rate").val("0.0");
        }
    }

    calculatePPM() {
        let ppm;
        let fatigue
        const maxTaktTime = parseFloat($("#max_takttime").val().toString());
        const fatigueValue = $("#elc_standard_fatigue").val().toString();
        if (fatigueValue == "")
            fatigue = 0
        else
            fatigue = parseFloat(fatigueValue);
        if (maxTaktTime > 0) {
            ppm = ((60.0 / maxTaktTime) * (1 - fatigue / 100.0)).toFixed(2);
        }
        else {
            ppm = 0;
        }
        $("#elc_standard_ppm").val(ppm);
        $("#unit_per_hour").val((ppm * 60.0).toFixed(2));
    }

    calculateStandardDlUnitCost () {
        let result;
        const empCount = parseInt($("#elc_standard_count_of_employee").val().toString());
        const areaRate = parseFloat($("#area_rate").val().toString());
        const unitPerHour = parseFloat($("#unit_per_hour").val().toString());
        if (unitPerHour > 0) {
            result = (empCount * areaRate) / unitPerHour;
        }
        else {
            result = 0;
        }
        $("#dl_unit_cost").val(result.toFixed(2));
    }
}

declare global {
    interface Window {
        ElcStandard: ElcStandard;
    }
}

export function LoadPage() {
    InitPage("elc", () => {
        InitPage("standards", () => {
            const elc_standard = new ElcStandard();
        });
    });

    InitPage("elc", () => {
        InitPage("standards new", () => {
            window.ElcStandard =  new ElcStandard();
            window.ElcStandard.initializeHTML();
        });
    });

    InitPage("elc", () => {
        InitPage("standards step_2", () => {
            window.ElcStandard =  new ElcStandard();
        });
    });
}
